import { Button, Result } from 'antd'
import { useNavigate } from 'react-router-dom'

type Status = '403' | '404' | '500' | 'offline'

interface HttpErrorPageProps {
  status: Status
  title?: string
  subTitle?: string
}

const DEFAULTS: Record<Status, { title: string; subTitle: string }> = {
  '403': {
    title: 'لا تملك صلاحية الوصول',
    subTitle: 'حسابك لا يملك صلاحية عرض هذه الصفحة. تواصل مع الإدارة إذا كنت تظن أن هذا خطأ.',
  },
  '404': {
    title: 'الصفحة غير موجودة',
    subTitle: 'الرابط الذي تتابعه قديم أو غير صحيح.',
  },
  '500': {
    title: 'خطأ في الخادم',
    subTitle: 'حدث خطأ غير متوقع على الخادم. الرجاء المحاولة بعد قليل.',
  },
  offline: {
    title: 'لا يوجد اتصال بالشبكة',
    subTitle: 'تحقق من اتصالك بالإنترنت ثم أعد المحاولة.',
  },
}

/**
 * Unified HTTP error page used by router error elements, 401 lockouts, etc.
 * Pass `status` to pick the visual + copy; override `title`/`subTitle` per use.
 */
export function HttpErrorPage({ status, title, subTitle }: HttpErrorPageProps) {
  const navigate = useNavigate()
  const defaults = DEFAULTS[status]
  const visualStatus = status === 'offline' ? '500' : status

  return (
    <Result
      status={visualStatus}
      title={title ?? defaults.title}
      subTitle={subTitle ?? defaults.subTitle}
      extra={[
        <Button key="home" type="primary" onClick={() => navigate('/')}>
          العودة للرئيسية
        </Button>,
        <Button key="back" onClick={() => navigate(-1)}>
          الرجوع
        </Button>,
      ]}
    />
  )
}

export default HttpErrorPage
